export default "__VITE_ASSET__DRjOv1ny__"